// Memory Lies — story content (the artist's text lives here, not in JS logic)
// Re-organise / re-order freely; do not alter wording without asking.

/** @type {string[]} */
export const INTRO_TEXTS = [
    "Incoming Transmission",
    "Please ensure your headphones are on securely.",
    "Click to receive transmission",
];

/**
 * @typedef {Object} Step
 * @property {string[]} info  The five info1..info5 text blocks (may be empty strings).
 * @property {number} videoStep  Arg to updateVideoTexture (0 = keep intro video).
 * @property {number} cameraDistance  Z-axis camera travel for the dolly.
 * @property {string} controlsInfo  Text for the "Click to ..." prompt.
 */

/** @type {Step[]} */
export const STEPS = [
    {
        info: [
            "Don't let anything distract you now.",
            "Enjoy these images you see before you. They are like memories, not entirely clear. Enjoy the silence they conjure up in your mind.",
            "Remember, there should be no distractions in this moment.",
            "Compliance is a non-negotiable fact... in the year 2060.",
            "",
        ],
        videoStep: 0,
        cameraDistance: 100,
        controlsInfo: "Click to Continue",
    },
    {
        info: [
            "The country has been in a state of emergency since the year 2020.",
            "A prolonged period of intensive social-distancing has been in place for the last 40 years.",
            "There is no opposition.",
            "There is no dissent.",
            "",
        ],
        videoStep: 1,
        cameraDistance: 50,
        controlsInfo: "Click to Continue",
    },
    {
        info: [
            "Do these images resonate with you somehow?",
            "Please ensure your headphones are on securely.",
            "Are you in a quiet space?",
            "That's good.",
            "Very good.",
        ],
        videoStep: 2,
        cameraDistance: 50,
        controlsInfo: "Click to Continue",
    },
    {
        info: ["Compliance is a non-negotiable fact.", "Stability.", "Together.", "Control.", "Apart."],
        videoStep: 3,
        cameraDistance: 50,
        controlsInfo: "Click to Continue",
    },
    {
        info: ["How do you hear your inner voice <b>in the future?</b>", "(Select an image)", "", "", ""],
        videoStep: 4,
        cameraDistance: 50,
        controlsInfo: "",
    },
    {
        info: ["Communications channel open", "Signal strength: Strong", "Loading...", "Area Bandwidth: Optimal", ""],
        videoStep: 0,
        cameraDistance: 0,
        controlsInfo: "",
    },
];

/** @type {string[]} */
export const CREDITS = [
    "Credits:",
    "Actors-Séamus O Donnell & Órla McGovern",
    "Photography- Emilia Jefremova www.emjcamera.com",
    "Sound Design-Niall Clarke",
    "Web Development/Design- Adrian Flaherty",
    "Music-Maitiú O Casaide",
    "Creative Development- Roisín Staic, Darach Mac Con Ionmaire",
    "Research support- Dr Mary Greene",
    "Special thanks to Lundahl & Seitl, Alice Keane, Jane Hanberry, Galway 2020 and Galway Theatre Festival team",
    "Refresh to restart Memory Lies",
];

/**
 * Per-voice audio cue thresholds (seconds).
 * @type {{1: {closeEyes: number, credits: number}, 2: {closeEyes: number, credits: number}}}
 */
export const AUDIO_CUES = {
    1: { closeEyes: 326, credits: 1076 },
    2: { closeEyes: 335, credits: 974 },
};

/** @type {string[]} */
export const CLOSE_EYES_1 = ["Please close your eyes", "ea6d3435", "c634d86c", "ea6d3435", "c634d86c", "..."];
/** @type {string[]} */
export const CLOSE_EYES_2 = ["Please close your eyes", "ea6d3435", "c634d86c", "ea6d3435", "c634d86c"];

/** Voice choice identifiers (also used as localStorage "selected" values). */
export const VOICE = {
    MALE: 1,
    FEMALE: 2,
};

/** Timing constants (ms) for transitions and typewriter. */
export const TIMINGS = {
    thisTweenTimer: 4000,
    titleTimer: 1200,
    fadeTimerTrans: 1000,
    letterTimer: 80,
    sentenceTimer: 1500,
};
